import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PmtEssentialsModule } from '@premotec/pmt-essentials';
import { PmtAgGridModule } from '@premotec/pmt-ag-grid';
import { PmtBootstrapModule } from '@premotec/pmt-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { PmtDatepickerModule } from '@premotec/pmt-datepicker';
import { DatePipe } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AgGridModule } from 'ag-grid-angular';
import { NgPipesModule } from 'ngx-pipes';
import { TranslocoModule } from '@jsverse/transloco';
import { PageDividerComponent } from './components/page-divider/page-divider.component';
import { RouterModule } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { CollapsibleCardComponent } from './components/collapsible-card/collapsible-card.component';
import { VersionUpdateModalComponent } from './components/version-update-modal/version-update-modal.component';
import { EnvironmentIndicatorComponent } from './components/environment-indicator/environment-indicator.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

const defaultModules = [CommonModule, FormsModule, ReactiveFormsModule];

const customModules = [
    ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        timeOut: 3000, // Auto-close in 3s,
        autoDismiss: true,
        closeButton: true,
        countDuplicates: true,
        preventDuplicates: true,
    }),
    NgSelectModule,
    TranslocoModule,
    AgGridModule,
    NgPipesModule,
];

const pmtModules = [
    PmtDatepickerModule,
    PmtEssentialsModule,
    PmtBootstrapModule.forRoot({
        pmtActionModalConfig: {
            modalHeaderClass: 'bg-white',
            modalFooterClass: 'bg-white',
            modalBodyClass: 'bg-white',
            modalTitleClass: 'h4',
            buttonCancelClass: 'btn btn-light',
            buttonSubmitClass: 'btn btn-primary'
        }
    }),
    PmtAgGridModule
];

@NgModule({
    imports: [
        defaultModules,
        customModules,
        pmtModules,
        RouterModule,
        TimepickerModule,
        EnvironmentIndicatorComponent,
        PageDividerComponent,
        SponsorsComponent,
        CollapsibleCardComponent,
        VersionUpdateModalComponent,
        SpinnerComponent,
        DateTimePickerComponent
    ],
    exports: [
        defaultModules,
        customModules,
        pmtModules,
        ReactiveFormsModule,
        TooltipModule,
        TabsModule,
        BsDropdownModule,
        EnvironmentIndicatorComponent,
        PageDividerComponent,
        SponsorsComponent,
        CollapsibleCardComponent,
        SpinnerComponent,
        DateTimePickerComponent
    ],
    providers: [DatePipe, BsModalService],
})
export class SharedModule { }
